

angular.module('admin')
.factory('scrollTo', function() {
	return function(x,y) {
		window.scrollTo(x,y);
	}
});
